import { render, staticRenderFns } from "./ConfirmWarningProp.vue?vue&type=template&id=5c5691b6&"
import script from "./ConfirmWarningProp.vue?vue&type=script&lang=js&"
export * from "./ConfirmWarningProp.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmWarningProp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports